import { formatDate } from '../../common/utils/date-utils'
import { UpdateUserDto } from '../../pages/users/api/dto/update/UpdateUserDto'
import { UpdateUserUI } from '../../pages/users/model/UpdateUserUI'
import Language from './Language'
import User from './User'

class UpdateUser {
  private constructor(
    email: string,
    firstName: string,
    lastName: string,
    fatherName: string | undefined,
    address: string | undefined,
    phoneNumber: string | undefined,
    mobileNumber: string | undefined,
    birthday: Date,
    idNumber: string,
    ssrNumber: string,
    vatNumber: string,
    visuallyImpaired: boolean,
    language: Language,
    sound: boolean,
  ) {
    this.email = email
    this.firstName = firstName
    this.lastName = lastName
    this.fatherName = fatherName ? fatherName : ''
    this.address = address ? address : ''
    this.phoneNumber = phoneNumber ? phoneNumber : ''
    this.mobileNumber = mobileNumber ? mobileNumber : ''
    this.birthday = birthday
    this.idNumber = idNumber
    this.ssrNumber = ssrNumber
    this.vatNumber = vatNumber
    this.visuallyImpaired = visuallyImpaired
    this.language = language
    this.sound = sound
  }

  private readonly email: string
  private readonly firstName: string
  private readonly lastName: string
  private readonly fatherName: string
  private readonly address: string
  private readonly phoneNumber: string
  private readonly mobileNumber: string
  private readonly birthday: Date
  private readonly idNumber: string
  private readonly ssrNumber: string
  private readonly vatNumber: string
  private readonly visuallyImpaired: boolean
  private readonly language: Language
  private readonly sound: boolean

  toUI(): UpdateUserUI {
    return {
      email: this.email,
      firstName: this.firstName,
      lastName: this.lastName,
      fatherName: this.fatherName,
      address: this.address,
      phoneNumber: this.phoneNumber,
      mobileNumber: this.mobileNumber,
      birthday: this.birthday,
      idNumber: this.idNumber,
      ssrNumber: this.ssrNumber,
      vatNumber: this.vatNumber,
      visuallyImpaired: this.visuallyImpaired,
      language: this.language,
      sound: this.sound,
    } satisfies UpdateUserUI
  }

  toDto(): UpdateUserDto {
    return {
      email: this.email,
      firstName: this.firstName,
      lastName: this.lastName,
      fatherName: this.fatherName,
      address: this.address,
      phoneNumber: this.phoneNumber,
      mobileNumber: this.mobileNumber,
      birthday: formatDate(this.birthday),
      idNumber: this.idNumber,
      ssrNumber: this.ssrNumber,
      vatNumber: this.vatNumber,
      visuallyImpaired: this.visuallyImpaired,
      language: this.language,
      sound: this.sound,
    } satisfies UpdateUserDto
  }

  static fromUpdateUserUI(updateUserUI: UpdateUserUI): UpdateUser {
    return new UpdateUser(
      updateUserUI.email,
      updateUserUI.firstName,
      updateUserUI.lastName,
      updateUserUI.fatherName,
      updateUserUI.address,
      updateUserUI.phoneNumber,
      updateUserUI.mobileNumber,
      updateUserUI.birthday,
      updateUserUI.idNumber,
      updateUserUI.ssrNumber,
      updateUserUI.vatNumber,
      updateUserUI.visuallyImpaired,
      updateUserUI.language,
      updateUserUI.sound,
    )
  }

  static fromUser(user: User): UpdateUser {
    const {
      email,
      firstName,
      lastName,
      fatherName,
      address,
      phoneNumber,
      mobileNumber,
      birthday,
      idNumber,
      ssrNumber,
      vatNumber,
      visuallyImpaired,
      language,
      sound,
    } = user.getInfo()
    return new UpdateUser(
      email,
      firstName,
      lastName,
      fatherName,
      address,
      phoneNumber,
      mobileNumber,
      birthday,
      idNumber,
      ssrNumber,
      vatNumber,
      visuallyImpaired,
      language,
      sound,
    )
  }
}

export default UpdateUser
